var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "no-data-wrapper",
    { attrs: { "has-data": _vm.hasData } },
    [
      _c("matrix-chart", {
        staticStyle: { height: "100%" },
        attrs: { data: _vm.chartData, options: _vm.chartOptions },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }